import type { UserWorkspace, Workspace } from "../../types"

export const WORKSPACE_SEARCH_THRESHOLD = 4
export const EXPANDED_WORKSPACE_LIST_THRESHOLD = 8

export const shouldShowWorkspaceSearch = (workspaceCount: number): boolean => (
  workspaceCount >= WORKSPACE_SEARCH_THRESHOLD
)

export const getWorkspaceDropdownHeightClass = (
  workspaceCount: number,
  showWorkspaceSearch: boolean,
): string => {
  if (!showWorkspaceSearch) return "h-[240px]"
  if (workspaceCount >= EXPANDED_WORKSPACE_LIST_THRESHOLD) return "h-[460px]"
  return "h-[300px]"
}

export const getNextWorkspaceIndex = (
  currentIndex: number,
  direction: 1 | -1,
  workspaceCount: number,
): number => {
  if (workspaceCount <= 0) return -1
  if (currentIndex < 0 || currentIndex >= workspaceCount) {
    return direction === 1 ? 0 : workspaceCount - 1
  }
  return (currentIndex + direction + workspaceCount) % workspaceCount
}

export const getHighlightedWorkspaceIndex = (
  keyboardActiveIndex: number,
  isKeyboardNavigating: boolean,
  selectedWorkspaceIndex: number,
  workspaceCount: number,
): number => {
  if (workspaceCount <= 0) return -1
  if (
    isKeyboardNavigating
    && keyboardActiveIndex >= 0
    && keyboardActiveIndex < workspaceCount
  ) {
    return keyboardActiveIndex
  }
  if (selectedWorkspaceIndex >= 0 && selectedWorkspaceIndex < workspaceCount) {
    return selectedWorkspaceIndex
  }
  return 0
}

export const filterWorkspaces = (
  workspaces: Workspace[],
  userWorkspaces: UserWorkspace[],
  searchValue: string,
): Workspace[] => {
  const query = searchValue.trim().toLowerCase()
  if (!query) return workspaces

  const domainMetadata = new Map(
    userWorkspaces.map((userWorkspace) => [
      userWorkspace.workspaceId,
      userWorkspace.hostnames ?? [],
    ]),
  )

  return workspaces.filter((workspace) => {
    if (workspace.name.toLowerCase().includes(query)) return true

    const hostnames = [
      ...(workspace.hostnames ?? []),
      ...(domainMetadata.get(workspace.id) ?? []),
    ]

    return hostnames.some((hostname) => (
      hostname.disabled !== true
      && hostname.hostname.toLowerCase().includes(query)
    ))
  })
}
